// Errors State

export default {
  errorsList: [],
  resetValidationErrors: false
}
